import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OperatorRole } from '@netsuite-ai/types';

interface AuthState {
  sessionToken: string | null;
  role: OperatorRole | null;
  setSession: (token: string, role: OperatorRole) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      sessionToken: null,
      role: null,
      setSession: (sessionToken, role) => set({ sessionToken, role }),
      clear: () => set({ sessionToken: null, role: null }),
    }),
    { name: 'console-auth' },
  ),
);
